export const OPENING_HOURS_TASK_VALUE = 'opening_hours';

export const OPENING_HOURS_DAYS = [
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
] as const;

export const OPENING_HOURS_WINDOWS = [
    'contact_transfer',
    'immediate_operator',
] as const;
